import { ExportVersionStatus } from 'common/types';
import { getNormalParams, FastApiAxiosInstance, FosAxiosInstance } from 'common/service/axiosInstances';

const exportVersions = {
  //获取当前任务版本列表
  getVersionList: async (taskId, listStatus: ExportVersionStatus): Promise<ExtendAxioResponse<any>> => {
    const params = { taskId };
    const { data } = await FastApiAxiosInstance.get('/api/v1/version/getVersionList', { params });
    return data;
  },
  updateVersionStatus: async (versionFileId: number, status) => {
    const res = await FastApiAxiosInstance.post<any, ExtendAxioResponse>('/api/v1/version/updateVersionStatus', {
      versionFileId: Number(versionFileId),
      status,
    });
    return res;
  },

  //根据version_file_id查询到出版本文件
  getTaskCurrentVersionFile: async (versionFileId: number | string) => {
    try {
      const params = { versionFileId: Number(versionFileId) };
      const { data } = await FastApiAxiosInstance.get<any, ExtendAxioResponse>(
        '/api/v1/version/getTaskCurrentVersionFile',
        {
          params,
        },
      );
      return data;
    } catch (error) {}
  },
  // 提交新版本的文件规则
  getVersionRule: async (taskId) => {
    try {
      const params = { ...getNormalParams('getVersionRule'), taskId };
      const {
        data: { versionFileSizeLimit: versionFileSizeLimitedBytes, file: rule },
      } = await FastApiAxiosInstance.get<any, ExtendAxioResponse>('/api/v1/template/getVersionRule', {
        params,
      });
      return { versionFileSizeLimitedBytes, rule };
    } catch (error) {}
  },

  // 获取p4v历史列表
  getP4vHistoryList: async (versionFileId) => {
    try {
      const params = { ...getNormalParams('getP4vLog'), versionFileId };
      const { data } = await FastApiAxiosInstance.get<any, ExtendAxioResponse>('/api/v1/version/getP4vLog', {
        params,
      });
      return data;
    } catch (error) {}
  },
  // 同步p4v路径
  pushP4v: async ({ path, versionFileId }) => {
    try {
      const params = {
        path,
        version_file_id: versionFileId,
      };
      const res = await FosAxiosInstance.get<any, ExtendAxioResponse>('/object-upload/api/pushP4v', {
        params,
      });
      return res;
    } catch (error) {}
  },
};

export default exportVersions;
